module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-footer u-relative u-marg-x-auto u-flex u-flex-ai--center u-flex-jc--center u-fit-w u-pad-y-xxxl@md u-bg--white-near u-overflow-h",
    style: ({
      'background-image': _vm.$root.width > _vm.$root.CONSTANTS.breakpoints.md ? '' : 'url(/static/medias/images/four-seasons_pattern.svg)',
      'background-position': _vm.$root.width > _vm.$root.CONSTANTS.breakpoints.md ? '' : 'center center',
      'background-size': _vm.$root.width > _vm.$root.CONSTANTS.breakpoints.md ? '' : 'cover',
      'background-repeat': _vm.$root.width > _vm.$root.CONSTANTS.breakpoints.md ? '' : 'no-repeat'
    })
  }, [_c('app-scroll-object', {
    attrs: {
      "is-parallax": true,
      "parallax-ratio": 0.1,
      "scale": 1.2,
      "is-centered": "xy"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _vm._m(0)
        
      },
      staticRenderFns: [function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "u-absolute u-pos-tl u-fit u-opacity--50"
          }, [_c('img', {
            staticClass: "u-absolute u-pos-center u-hide@md u-minw--100 u-minh--100 u-fit-w",
            attrs: {
              "src": "/static/medias/images/four-seasons_pattern.svg",
              "alt": "Four Seasons - Pattern",
              "title": "Four Seasons - Pattern"
            }
          })])
        
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-page-footer__wrapper u-absolute u-relative@md u-pos-center u-pos-tl@md u-zindex--2 u-w6of10 u-w8of10@md u-align-center"
  }, [_c('h3', [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--light t-text--lg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-md"
  }, [_c('app-cta', {
    attrs: {
      "label": _vm.linkLabel,
      "href": _vm.$root.getPageURLFromName(_vm.page.post_name)
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-619975d1"}!./src/scripts/components/app-page-footer/template.html
// module id = 196
// module chunks = 0